module.exports = __webpack_public_path__ + "static/media/plaid-logo.d7f837a8.png";